import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import Home from './pages/home';
import './styles/globals.css';
import { getApiUrl } from './lib/api-config';

// Global fetch wrapper: automatically routes to backend and adds auth headers
const originalFetch = window.fetch;
window.fetch = function(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  let url = typeof input === 'string' ? input : input.toString();

  // If URL is relative (starts with /), use getApiUrl to convert to absolute backend URL
  if (typeof url === 'string' && url.startsWith('/')) {
    url = getApiUrl(url);
  }

  // Add auth token to headers if available
  const token = localStorage.getItem('access_token');
  if (token) {
    const headers = init?.headers || {};
    const headersObject = new Headers(headers);
    if (!headersObject.has('Authorization')) {
      headersObject.set('Authorization', `Bearer ${token}`);
    }
    init = { ...init, headers: headersObject };
  }

  return originalFetch(url, init);
} as typeof window.fetch;

// Use environment variable for redirect URI, default to current location
const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL || `${window.location.origin}/auth0-callback`;

// Allow disabling Auth0 for local network testing with VITE_DISABLE_AUTH0=true
const useAuth0 = import.meta.env.VITE_DISABLE_AUTH0 !== 'true';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {useAuth0 ? (
      <Auth0Provider
        domain="voiceplatform.eu.auth0.com"
        clientId="6UpKaSZwjgIhd6bsdXb1U1HnAQcxL7E7"
        authorizationParams={{
          redirect_uri: redirectUri,
          organization: 'org_FJb9rL28000GRye7',
        }}
      >
        <Home />
      </Auth0Provider>
    ) : (
      <Home />
    )}
  </React.StrictMode>,
);
